@if (errors().length > 0) {
  <ul>
    @for (msg of errors(); track $index) {
      <li>
        <p-message severity="error" variant="simple" size="small">
          {{ msg }}
        </p-message>
      </li>
    }
  </ul>
}
